

import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaSave } from "react-icons/fa";
import axios from "axios";
import zIndex from "@mui/material/styles/zIndex";

const Employee = () => {
    // const [employees, setEmployees] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editEmployeeId, setEditEmployeeId] = useState(null);
    const [vendorId, setVendorId] = useState(null);

    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        city: "",
        businessCategory: "FOOD_AND_BEVERAGES",
        username: "sddeda",
        password: "",
        role: "",
        roles: [], // ✅ IMPORTANT
        businessModules: [], // ✅

    });




    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);
    const employeeData = {
        ...form,
        employeeRoles: form.employeeRoles, // ✅ Single role as enum value
    };


    const categories = ["Food", "Rooms", "BanquetHalls", "Fashions", "Groceries"];
    const modules = [
        "Home",
        "Company",
        "Settings_Controls",
        "Account_History",
        "Order_Management",
        "Menu_Management",
        "Inventory_Management",
        "Chef_Management",
        "Payment_Transactions",
        "Table_Management",
        "Delivery_Management",
        "Promotions_Discounts",
        "Report_Analysis",
        "Pay_outs"
    ];


    const generateUsername = () => {

    };

    const generatePassword = () => {

    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const roleOptions = [
        { label: "Manager", value: "Manager" },
        { label: "Waiter", value: "Waiter" },
        { label: "Chef All", value: "Chef_All" },
        { label: "Chef North", value: "Chef_North" },
        { label: "Chef South", value: "Chef_South" },
        { label: "Chef Chines", value: "Chef_Chinese" },
        { label: "Chef Continental", value: "Chef_Continental" },

    ];

    const toggleRole = (roleValue) => {
        setForm((prevForm) => {
            const currentRoles = prevForm.roles || [];
            const newRoles = currentRoles.includes(roleValue)
                ? currentRoles.filter((r) => r !== roleValue)
                : [...currentRoles, roleValue];

            return { ...prevForm, roles: newRoles };
        });
    };






    const toggleModule = (module) => {
        setForm((prevForm) => {
            const current = prevForm.businessModules || [];
            const newModules = current.includes(module)
                ? current.filter((m) => m !== module)
                : [...current, module];
            return { ...prevForm, businessModules: newModules };
        });
    };


    const handleSubmit = async () => {
        const parentId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!parentId) {
            alert("Parent ID not found. Please login again.");
            return;
        }

        const payload = {
            vendorId: 0,
            name: `${form.firstName} ${form.lastName}`,
            email: form.email,
            mobileNumber: form.mobileNumber,
            city: form.city || "Unknown",
            businessVertical: form.businessCategory,
            parentId: Number(parentId),
            username: "dsafre",
            password: form.password,
            enabled: true,
            employeRole: form.roles[0] || "Manager", // ✅ send only one role as string
            role: form.role || "VENDOR",
            accountNonLocked: true,
            accountNonExpired: true,
            credentialsNonExpired: true,
            businessModules: form.businessModules || [],

        };

        try {
            const response = await axios.post(
                "https://backend.maamaas.com/food/vendor-enquiries",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            console.log("✅ Employee added:", response.data);
            alert("Employee added successfully!");
            setShowModal(false);   // Optional: Close modal
            window.location.reload(); // ✅ Reload the page
        } catch (error) {
            console.error("❌ Error adding employee:", {
                message: error.message,
                status: error.response?.status,
                data: error.response?.data,
            });
            alert("Failed to add employee.");
        }
    };





    const [employees, setEmployees] = useState([]);

    const fetchEmployees = async () => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!token || !vendorId) {
            alert("Missing authToken or vendorId in localStorage.");
            return;
        }

        try {
            const res = await axios.get(
                `https://backend.maamaas.com/food/vendor-enquiries/get-employees/${vendorId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            // Filter to show only employees added by this vendor (children)
            const filtered = res.data.filter(emp => emp.parentId && emp.parentId !== 0);
            setEmployees(filtered);
        } catch (error) {
            console.error("❌ Failed to fetch employees:", error);
            alert("Failed to fetch employee list. Check console for details.");
        }
    };

    useEffect(() => {
        fetchEmployees(); // Fetch on component mount
    }, []);


    useEffect(() => {
        fetchEmployees();
    }, []);
    // const handleDelete = (index) => {
    //     setEmployees(prev => prev.filter((_, i) => i !== index));
    // };
    const updateEmployee = async () => {
        if (!editEmployeeId) {
            alert("❌ No employee selected for update.");
            return;
        }

        // Prepare payload
        const employeeData = {
            firstName: form.name?.trim() || "",
            // lastName: form.lastName?.trim() || "",
            email: form.email?.trim() || "",
            mobileNumber: form.mobileNumber?.trim() || "",
            username: form.username?.trim() || "",
            employeeRoles: Array.isArray(form.employeeRoles)
                ? form.employeeRoles[0] || ""
                : form.employeeRoles || "",
            businessCategory: form.businessCategory || "",
            businessModules: Array.isArray(form.businessModules)
                ? form.businessModules
                : (typeof form.businessModules === "string"
                    ? form.businessModules.split(",").map(item => item.trim())
                    : []),
        };

        // Log final payload
        console.log("📦 Final Payload to Send:", JSON.stringify(employeeData, null, 2));
        console.log("🆔 Updating Employee ID:", editEmployeeId);

        try {
            const response = await fetch(
                `https://backend.maamaas.com/food/api/employees/${editEmployeeId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(employeeData),
                }
            );

            // Get server response
            const contentType = response.headers.get("content-type");
            const responseBody = contentType && contentType.includes("application/json")
                ? await response.json()
                : await response.text();

            console.log("🧾 Server Response:", responseBody);

            if (!response.ok) {
                throw new Error(`❌ Failed to update (Status ${response.status}): ${JSON.stringify(responseBody)}`);
            }

            // Success: update list and close modal
            alert("✅ Employee updated successfully!");
            fetchEmployees();
            setShowModal(false);
        } catch (error) {
            console.error("❌ Update Error:", error);
            alert("❌ Update failed: " + error.message);
        }
    };





    const handleDelete = async (vendorId) => {
        if (!vendorId) return alert("Invalid employee ID");

        try {
            const res = await fetch(`https://backend.maamaas.com/food/vendor-enquiries/delete/${vendorId}`, {
                method: 'DELETE',
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!res.ok) throw new Error(`Failed to delete. Status ${res.status}`);

            setEmployees(prev => prev.filter(emp => emp.vendorId !== vendorId));
            alert("Employee deleted successfully.");
        } catch (err) {
            alert("Delete Error: " + err.message);
        }
    };




    return (
        <div className="billingswaraper" style={{ padding: "0px" }}>
            <button onClick={() => {
                setShowModal(true);
                setIsEditing(false);
                setEditIndex(null);
                setForm({
                    firstName: "",
                    lastName: "",
                    email: "",
                    mobileNumber: "",
                    employeeRoles: [],
                    businessCategory: "FOOD_AND_BEVERAGES",
                    businessModules: [],
                    username: "",
                    password: "",
                });
            }} style={addButtonStyle}>Add+</button>

            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "-10px" }}>
                <thead>
                    <tr>
                        <th style={thStyle}>#</th>
                        <th style={thStyle}>Name</th>
                        <th style={thStyle}>Role</th>
                        <th style={thStyle}>Email</th>
                        <th style={thStyle}>Mobile</th>
                        <th style={thStyle}>Category</th>
                        <th style={thStyle}>Modules</th>
                        <th style={thStyle}>Username</th>
                        <th style={thStyle}>Password</th>
                        <th style={thStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(employees) &&
                        employees.map((emp, i) => (
                            <tr key={emp.id || i} style={i % 2 === 0 ? evenRow : oddRow}>
                                <td style={tdStyle}>{i + 1}</td>
                                <td style={tdStyle}>{emp.name} {emp.lastName}</td>
                                <td style={tdStyle}>
                                    {Array.isArray(emp.role)
                                        ? emp.employeeRoles.join(", ")
                                        : typeof emp.role === "string"
                                            ? emp.role
                                            : ""}
                                </td>
                                <td style={tdStyle}>{emp.email}</td>
                                <td style={tdStyle}>{emp.mobileNumber}</td>
                                <td style={tdStyle}>{emp.employeRole}</td>
                                <td style={tdStyle}>
                                    {Array.isArray(emp.businessModules)
                                        ? emp.businessModules.map((mod, index) => <div key={index}>{mod}</div>)
                                        : null}
                                </td>
                                <td style={tdStyle}>{emp.username}</td>
                                <td style={tdStyle}>{emp.password}</td>
                                <td style={tdStyle}>
                                    <button
                                        onClick={() => {
                                            setForm(emp);
                                            setEditEmployeeId(emp.id);
                                            setIsEditing(true);
                                            setEditIndex(i);
                                            setShowModal(true);
                                        }}
                                        style={deleteButtonStylee}
                                    >
                                        <FaEdit />
                                    </button>
                                    <button onClick={() => handleDelete(emp.vendorId)} style={deleteButtonStyle}>
                                        <FaTrash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                </tbody>


            </table>

            {showModal && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3>{isEditing ? "Edit Employee" : "Add Employee"}</h3>
                        <input type="text" name="firstName" placeholder="First Name" value={form.name} onChange={handleChange} style={inputStyle} />
                        {/* <input type="text" name="lastName" placeholder="Last Name" value={form.lastName} onChange={handleChange} style={inputStyle} /> */}
                        <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} style={inputStyle} />
                        <input type="text" name="mobileNumber" placeholder="Mobile Number" value={form.mobileNumber} onChange={handleChange} style={inputStyle} />

                        <div>
                            <label>Roles:</label>
                            {roleOptions.map(({ label, value }) => (
                                <label key={value} style={{ marginRight: "10px" }}>
                                    <input
                                        type="checkbox"
                                        checked={form.roles?.includes(value)}
                                        onChange={() => toggleRole(value)}
                                    />
                                    {label}
                                </label>
                            ))}
                        </div>








                        {/* <div style={{ marginTop: "10px" }}>
                            <label>Category:</label>
                            <select
                                name="businessCategory"
                                value={form.businessCategory}
                                onChange={handleChange}  // ✅ this is important
                                style={inputStyle}
                            >
                                {categories.map(c => (
                                    <option key={c} value={c}>
                                        {c}
                                    </option>
                                ))}
                            </select>
                        </div> */}

                        <div style={{ marginTop: "10px" }}>
                            <label>Modules:</label>
                            {modules.map((module) => (
                                <label key={module} style={{ marginRight: "10px" }}>
                                    <input
                                        type="checkbox"
                                        checked={form.businessModules.includes(module)}
                                        onChange={() => toggleModule(module)}
                                    />
                                    {module.replace(/_/g, " ")} {/* Optional: make labels readable */}
                                </label>
                            ))}
                        </div>


                        <div style={{ marginTop: "20px", textAlign: "right" }}>
                            <button style={saveButton} onClick={isEditing ? updateEmployee : handleSubmit}>
                                {isEditing ? "Update" : "Add"} Employee
                            </button>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    setIsEditing(false);
                                    setEditIndex(null);
                                    setForm({
                                        firstName: "",
                                        lastName: "",
                                        email: "",
                                        mobileNumber: "",
                                        employeeRoles: [],
                                        businessCategory: "FOOD_AND_BEVERAGES",
                                        businessModules: [],
                                        username: "",
                                        password: "",
                                    });
                                }}
                                style={cancelButton}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
//  all the 

// Styles
const thStyle = {
    border: "1px solid #ccc",
    backgroundColor: "#b15cd6",
    color: "#fff",
    padding: "8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "150px"
};

const tdStyle = {
    border: "1px solid #ccc",
    textAlign: "center",
    padding: "8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "97px",
    width: "150px",
    boxSizing: "border-box"
};

const evenRow = { backgroundColor: "#f9f9f9" };
const oddRow = { backgroundColor: "#fff" };
const inputStyle = { width: "100%", margin: "5px 0", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" };
const addButtonStyle = { marginBottom: "15px", padding: "10px 20px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: "4px", fontWeight: "bold" };
const saveButton = { padding: "8px 15px", backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", marginRight: "10px" };
const cancelButton = { padding: "8px 15px", backgroundColor: "#ccc", color: "#fff", border: "none", borderRadius: "4px" };
const deleteButtonStyle = { backgroundColor: "#f44336", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
const deleteButtonStylee = { backgroundColor: "blue", border: "none", color: "white", borderRadius: "4px", cursor: "pointer", marginRight: "10px" };
const modalOverlay = {
    position: "fixed",
    top: 35,
    left: 0,
    zIndex: 1111,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
const modalContent = {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "500px",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)", // Adds depth
    display: "flex",
    flexDirection: "column",
    gap: "16px" // Space between form elements
};

const checkboxLabel = {
    marginRight: "10px",
    display: "inline-block"
};

export default Employee;

